import axios from "axios";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Back from "../components/button/back";

const Prestasi = () => {
  const [prestasi, setPrestasi] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchPrestasi = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}api/prestasi`
      );
      setPrestasi(res.data);
    } catch (err) {
      toast.error("Gagal memuat prestasi.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPrestasi();
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 p-6">
      <div className="pt-5 pb-5 pl-5">
        <Link to="/">
          <Back />
        </Link>
      </div>
      <ToastContainer />
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl font-semibold mb-6 text-center">
          Daftar Prestasi
        </h2>

        {loading ? (
          <p className="text-center text-gray-600">Memuat...</p>
        ) : prestasi.length === 0 ? (
          <p className="text-center text-gray-500">Belum ada data prestasi.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {prestasi.map((item) => (
              <div
                key={item._id}
                onClick={() => navigate(`/prestasi/${item._id}`)}
                className="bg-white rounded shadow p-4 cursor-pointer hover:shadow-md transition"
              >
                <img
                  src={`${process.env.REACT_APP_API_URL}api/prestasi/gambar/${item.gambar?.filename}`}
                  alt="Prestasi"
                  className="w-full h-48 object-cover rounded mb-2"
                />
                <h3 className="font-semibold text-lg mb-1">{item.judul}</h3>
                <p className="text-sm text-gray-600 mb-2">{item.deskripsi}</p>
              </div>
            ))}
          </div>
        )}
      </div>
      <div className="pt-5 pb-5 pl-5">
        <Link to="/">
          <Back />
        </Link>
      </div>
    </div>
  );
};

export default Prestasi;
